// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Emotion = require("emotion");
var ReactUpdate = require("reason-react-update/src/ReactUpdate.bs.js");
var TicTacToeLogic$ReactTemplate = require("./TicTacToeLogic.bs.js");

var initialState_status = TicTacToeLogic$ReactTemplate.status(TicTacToeLogic$ReactTemplate.initial_game);

var initialState = {
  game: TicTacToeLogic$ReactTemplate.initial_game,
  status: initialState_status
};

function reducer(useBrokenLogic, action, state) {
  if (action) {
    var partial_arg = useBrokenLogic ? TicTacToeLogic$ReactTemplate.is_valid_move_broken : TicTacToeLogic$ReactTemplate.is_valid_move;
    var play = function (param, param$1) {
      return TicTacToeLogic$ReactTemplate.play(partial_arg, param, param$1);
    };
    var match = Curry._2(play, state.game, action[0]);
    var status = match[1];
    var newState_game = match[0];
    var newState = {
      game: newState_game,
      status: status
    };
    return /* Update */Block.__(0, [newState]);
  } else {
    return /* Update */Block.__(0, [initialState]);
  }
}

function TicTacToe(Props) {
  var useBrokenLogic = Props.useBrokenLogic;
  var match = ReactUpdate.useReducer(initialState, (function (param, param$1) {
          return reducer(useBrokenLogic, param, param$1);
        }));
  var send = match[1];
  var state = match[0];
  var label = function (s) {
    if (s !== undefined) {
      if (s) {
        return "O";
      } else {
        return "X";
      }
    } else {
      return "";
    }
  };
  var match$1 = state.status;
  var disabled;
  disabled = typeof match$1 === "number" ? (
      match$1 === /* InProgress */0 ? false : true
    ) : (
      match$1.tag ? false : true
    );
  var buttonCss = function (b) {
    var base = Emotion.css("display: block; width: 78px; height: 78px; margin: 3px;");
    var match = state.status;
    if (typeof match === "number" || !(match.tag === /* InvalidMove */1 && b === match[0])) {
      return base;
    } else {
      return base + (" " + Emotion.css("border: solid 1px red !important"));
    }
  };
  var match$2 = state.status;
  var overlay;
  overlay = typeof match$2 === "number" ? (
      match$2 === /* InProgress */0 ? undefined : "="
    ) : (
      match$2.tag ? undefined : (
          match$2[0] ? "O" : "X"
        )
    );
  var rowCss = Emotion.css("display: flex; flex-direction: row");
  var elems = React.createElement("div", undefined, React.createElement("div", {
            className: rowCss
          }, React.createElement("button", {
                className: buttonCss(/* A */0),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* A */0]);
                  })
              }, label(state.game.grid.a)), React.createElement("button", {
                className: buttonCss(/* B */1),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* B */1]);
                  })
              }, label(state.game.grid.b)), React.createElement("button", {
                className: buttonCss(/* C */2),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* C */2]);
                  })
              }, label(state.game.grid.c))), React.createElement("div", {
            className: rowCss
          }, React.createElement("button", {
                className: buttonCss(/* D */3),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* D */3]);
                  })
              }, label(state.game.grid.d)), React.createElement("button", {
                className: buttonCss(/* E */4),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* E */4]);
                  })
              }, label(state.game.grid.e)), React.createElement("button", {
                className: buttonCss(/* F */5),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* F */5]);
                  })
              }, label(state.game.grid.f))), React.createElement("div", {
            className: rowCss
          }, React.createElement("button", {
                className: buttonCss(/* G */6),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* G */6]);
                  })
              }, label(state.game.grid.g)), React.createElement("button", {
                className: buttonCss(/* H */7),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* H */7]);
                  })
              }, label(state.game.grid.h)), React.createElement("button", {
                className: buttonCss(/* I */8),
                disabled: disabled,
                onClick: (function (_event) {
                    return Curry._1(send, /* Move */[/* I */8]);
                  })
              }, label(state.game.grid.i))));
  var sub = overlay !== undefined ? [
      elems,
      React.createElement("div", {
            className: Emotion.css("position: absolute; top: 0; left: 0; width: 100%; height: 100%; text-align: center; font-size: 150px; display: flex; flex-direction: row; justify-content: space-around; background: #FBFBFB; color: #3276B5; user-select: none; cursor: pointer;"),
            onClick: (function (_event) {
                return Curry._1(send, /* Restart */0);
              })
          }, React.createElement("div", {
                className: Emotion.css("display: flex; flex-direction: column; justify-content: space-around;")
              }, overlay))
    ] : [elems];
  return React.createElement("div", {
              className: Emotion.css("position: relative; display: flex;")
            }, sub);
}

var make = TicTacToe;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* initialState Not a pure module */
